/**
 * Telling av besøk.
 *
 * Databasen vet alt om hvordan appen brukes etter innlogging - hvert gjøremål
 * og hver postering er en rad med et tidspunkt, og scripts/stats.sh leser det
 * rett ut. Det den ikke kan vite noe om, er alt som skjer FØR det finnes en
 * familie: hvor mange som var innom, hvor mange som prøvde demoen, hvor mange
 * som begynte på registreringen og snudde. Det er det denne fila er til for.
 *
 * Tellingen gjøres av Umami på vår egen tjener. Den setter ingen
 * informasjonskapsler, lagrer ingenting i nettleseren og sender ingenting til
 * noen tredjepart.
 *
 * HVORFOR /telle/ OG IKKE ET ANNET DOMENE: skriptet lastes fra appens egen
 * adresse. En teller på et fremmed domene blokkeres av annonseblokkerere og av
 * nettleserens sporingsvern, og ville i tillegg trengt CORS-oppsett. Skriptet
 * sender hendelsene til sin egen mappe + /api/send, altså /telle/api/send;
 * begge stiene rutes videre i deploy/nginx/app.conf.
 *
 * ALDRI SEND PERSONOPPLYSNINGER HERFRA. Ingen familie-ID, ingen navn, ingen
 * e-post, ingen beløp. Hendelsene under er navn uten innhold, og skal fortsatt
 * være det. Så lenge det holdes slik, er dette anonym statistikk uten krav om
 * samtykkebanner - og det er verdt å beholde i en app om barns penger.
 */
import { UMAMI_WEBSITE_ID } from './config'

const SCRIPT_URL = '/telle/script.js'

/** Hendelser meldt inn før skriptet rakk å laste. */
const venter = []
let klar = false

/**
 * Laster sporingsskriptet, hvis det er satt opp. Kalles én gang ved oppstart.
 *
 * Umami følger selv med på sidebytter i en SPA - den hekter seg på
 * history.pushState - så rutene i appen telles uten at noe mer gjøres her.
 */
export function startAnalytics() {
  if (!UMAMI_WEBSITE_ID) return
  if (document.querySelector(`script[src="${SCRIPT_URL}"]`)) return

  const el = document.createElement('script')
  el.src = SCRIPT_URL
  el.defer = true
  el.setAttribute('data-website-id', UMAMI_WEBSITE_ID)

  // Skriptet er defer, så det er ikke lastet når appen starter. Hendelser som
  // meldes inn i mellomtiden - demo-apnet er den første som skjer - ville
  // ellers forsvunnet stille.
  el.addEventListener('load', () => {
    klar = true
    for (const event of venter.splice(0)) send(event)
  })

  document.head.appendChild(el)
}

function send(event) {
  try {
    window.umami?.track(event)
  } catch {
    /* telling skal aldri kunne velte appen */
  }
}

/**
 * Teller en navngitt hendelse. Ingen data følger med - se toppen av fila.
 */
export function track(event) {
  if (!UMAMI_WEBSITE_ID) return
  if (klar) return send(event)

  // Taket er en sikring for tilfellet der skriptet aldri laster, f.eks. fordi
  // en blokkerer stopper det. Da skal køen slutte å vokse, ikke fylle minnet.
  if (venter.length < 20) venter.push(event)
}
